import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=30b56852&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30b56852')) {
      api.createRecord('30b56852', component.options)
    } else {
      api.reload('30b56852', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=30b56852&", function () {
      api.rerender('30b56852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2M8rXvHs5V9e8/JS/comp/ErrorMessage.vue"
export default component.exports